var _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4858 7.07765L23.4977 3.20871C28.6038 1.79882 32.3026 4.09885 33.7248 9.56824L37.6236 24.5627C39.0458 30.0321 36.9585 33.9297 31.8524 35.3396L17.8405 39.2085C12.7344 40.6184 9.04894 38.3147 7.62678 32.8453L3.7279 17.8509C2.30574 12.3815 4.37967 8.48754 9.4858 7.07765Z",
    fill: "#B7B8B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27429_111861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.103 11.7043L22.6159 9.07766C26.0825 8.12046 28.5664 9.57693 29.4837 13.1048L31.9985 22.7764C32.9158 26.3042 31.4714 28.8454 28.0048 29.8026L18.4919 32.4292C15.0253 33.3864 12.5505 31.9275 11.6332 28.3996L9.11833 18.728C8.20102 15.2002 9.63636 12.6615 13.103 11.7043Z",
    fill: "url(#paint0_linear_27429_111861)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_27429_111861)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_27429_111861",
    maskUnits: "userSpaceOnUse",
    x: 10.7448,
    y: 9.18359,
    width: 37,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.7448,
    y: 9.18359,
    width: 37,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 10.1836H21.007C15.0812 10.1836 11.7448 13.6218 11.7448 19.7282V36.4537C11.7448 42.5243 15.0812 45.9984 21.007 45.9984H37.2377C43.1461 45.9984 46.4999 42.5243 46.4999 36.4537V19.7282C46.4999 13.6218 43.1287 10.1836 37.2203 10.1836Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 10.1836H21.007C15.0812 10.1836 11.7448 13.6218 11.7448 19.7282V36.4537C11.7448 42.5243 15.0812 45.9984 21.007 45.9984H37.2377C43.1461 45.9984 46.4999 42.5243 46.4999 36.4537V19.7282C46.4999 13.6218 43.1287 10.1836 37.2203 10.1836Z",
    fill: "#B3B3B3",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2203 11.1836C37.7726 11.1836 38.2203 10.7359 38.2203 10.1836C38.2203 9.63131 37.7726 9.18359 37.2203 9.18359V11.1836ZM37.2203 9.18359C36.668 9.18359 36.2203 9.63131 36.2203 10.1836C36.2203 10.7359 36.668 11.1836 37.2203 11.1836V9.18359ZM37.2203 9.18359H21.007V11.1836H37.2203V9.18359ZM21.007 9.18359C17.8514 9.18359 15.2473 10.1032 13.4361 11.9696C11.6292 13.8316 10.7448 16.4987 10.7448 19.7282H12.7448C12.7448 16.8513 13.5286 14.7462 14.8714 13.3624C16.2099 11.9831 18.2368 11.1836 21.007 11.1836V9.18359ZM10.7448 19.7282V36.4537H12.7448V19.7282H10.7448ZM10.7448 36.4537C10.7448 39.6667 11.6299 42.3326 13.4351 44.198C15.245 46.0682 17.8486 46.9984 21.007 46.9984V44.9984C18.2397 44.9984 16.2121 44.1916 14.8723 42.8071C13.5279 41.4178 12.7448 39.3114 12.7448 36.4537H10.7448ZM21.007 46.9984H37.2377V44.9984H21.007V46.9984ZM37.2377 46.9984C40.3881 46.9984 42.991 46.0678 44.8026 44.1984C46.6097 42.3337 47.4999 39.668 47.4999 36.4537H45.4999C45.4999 39.31 44.7132 41.4167 43.3663 42.8066C42.0239 44.1919 39.9957 44.9984 37.2377 44.9984V46.9984ZM47.4999 36.4537V19.7282H45.4999V36.4537H47.4999ZM47.4999 19.7282C47.4999 16.496 46.6053 13.829 44.792 11.9681C42.975 10.1035 40.3678 9.18359 37.2203 9.18359V11.1836C39.9812 11.1836 42.0138 11.9828 43.3596 13.3639C44.7089 14.7487 45.4999 16.854 45.4999 19.7282H47.4999Z",
    fill: "url(#paint1_linear_27429_111861)",
    mask: "url(#path-3-outside-1_27429_111861)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_27429_111861)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_27429_111861",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4825 29.5775H30.5473V34.6453C30.5473 35.469 29.9043 36.1316 29.1049 36.1316C28.3055 36.1316 27.6626 35.469 27.6626 34.6453V29.5775H22.7447C21.9453 29.5596 21.3024 28.897 21.3024 28.0733C21.3024 27.6775 21.4588 27.3033 21.7194 27.0168C21.9975 26.7481 22.3624 26.587 22.7447 26.587H27.6626V21.5371C27.6626 20.7134 28.3055 20.0508 29.1049 20.0508C29.9043 20.0508 30.5473 20.7134 30.5473 21.5371V26.587H35.4825C36.2819 26.587 36.9248 27.2496 36.9248 28.0733C36.9248 28.897 36.2819 29.5596 35.4825 29.5775Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4825 29.5775H30.5473V34.6453C30.5473 35.469 29.9043 36.1316 29.1049 36.1316C28.3055 36.1316 27.6626 35.469 27.6626 34.6453V29.5775H22.7447C21.9453 29.5596 21.3024 28.897 21.3024 28.0733C21.3024 27.6775 21.4588 27.3033 21.7194 27.0168C21.9975 26.7481 22.3624 26.587 22.7447 26.587H27.6626V21.5371C27.6626 20.7134 28.3055 20.0508 29.1049 20.0508C29.9043 20.0508 30.5473 20.7134 30.5473 21.5371V26.587H35.4825C36.2819 26.587 36.9248 27.2496 36.9248 28.0733C36.9248 28.897 36.2819 29.5596 35.4825 29.5775Z",
    fill: "url(#paint2_linear_27429_111861)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5473 29.5775V29.3775H30.3473V29.5775H30.5473ZM27.6626 29.5775H27.8626V29.3775H27.6626V29.5775ZM22.7447 29.5775L22.7402 29.7775H22.7447V29.5775ZM21.7194 27.0168L21.5802 26.8726L21.5715 26.8822L21.7194 27.0168ZM27.6626 26.587V26.787H27.8626V26.587H27.6626ZM30.5473 26.587H30.3473V26.787H30.5473V26.587ZM35.4825 29.3775H30.5473V29.7775H35.4825V29.3775ZM30.3473 29.5775V34.6453H30.7473V29.5775H30.3473ZM30.3473 34.6453C30.3473 35.3643 29.7882 35.9316 29.1049 35.9316V36.3316C30.0204 36.3316 30.7473 35.5738 30.7473 34.6453H30.3473ZM29.1049 35.9316C28.4216 35.9316 27.8626 35.3643 27.8626 34.6453H27.4626C27.4626 35.5738 28.1895 36.3316 29.1049 36.3316V35.9316ZM27.8626 34.6453V29.5775H27.4626V34.6453H27.8626ZM27.6626 29.3775H22.7447V29.7775H27.6626V29.3775ZM22.7492 29.3776C22.0615 29.3622 21.5024 28.7913 21.5024 28.0733H21.1024C21.1024 29.0028 21.8292 29.7571 22.7402 29.7775L22.7492 29.3776ZM21.5024 28.0733C21.5024 27.7307 21.6378 27.4036 21.8674 27.1513L21.5715 26.8822C21.2797 27.2029 21.1024 27.6244 21.1024 28.0733H21.5024ZM21.8584 27.1606C22.1029 26.9244 22.4193 26.787 22.7447 26.787V26.387C22.3055 26.387 21.892 26.5719 21.5805 26.8729L21.8584 27.1606ZM22.7447 26.787H27.6626V26.387H22.7447V26.787ZM27.8626 26.587V21.5371H27.4626V26.587H27.8626ZM27.8626 21.5371C27.8626 20.8181 28.4216 20.2508 29.1049 20.2508V19.8508C28.1895 19.8508 27.4626 20.6086 27.4626 21.5371H27.8626ZM29.1049 20.2508C29.7882 20.2508 30.3473 20.8181 30.3473 21.5371H30.7473C30.7473 20.6086 30.0204 19.8508 29.1049 19.8508V20.2508ZM30.3473 21.5371V26.587H30.7473V21.5371H30.3473ZM30.5473 26.787H35.4825V26.387H30.5473V26.787ZM35.4825 26.787C36.1658 26.787 36.7248 27.3543 36.7248 28.0733H37.1248C37.1248 27.1448 36.3979 26.387 35.4825 26.387V26.787ZM36.7248 28.0733C36.7248 28.7913 36.1657 29.3622 35.478 29.3776L35.487 29.7775C36.398 29.7571 37.1248 29.0028 37.1248 28.0733H36.7248Z",
    fill: "url(#paint3_linear_27429_111861)",
    fillOpacity: 0.5,
    mask: "url(#path-5-inside-2_27429_111861)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27429_111861",
    x: -7.15234,
    y: -7.21094,
    width: 55.4207,
    height: 55.9258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_27429_111861"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_27429_111861",
    x: -13.2552,
    y: -14.8164,
    width: 84.7552,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_27429_111861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_27429_111861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_27429_111861",
    x: 16.3024,
    y: 15.0508,
    width: 35.6224,
    height: 36.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72845 0 0 0 0 0.785198 0 0 0 0 0.740934 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_27429_111861"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_27429_111861",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27429_111861",
    x1: 17.864,
    y1: 10.3897,
    x2: 23.5629,
    y2: 31.0291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3E1DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27429_111861",
    x1: 17.2772,
    y1: 14.3561,
    x2: 40.2583,
    y2: 41.9766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27429_111861",
    x1: 35.8172,
    y1: 22.9547,
    x2: 18.4142,
    y2: 23.5059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_27429_111861",
    x1: 22.9852,
    y1: 25.4451,
    x2: 36.2509,
    y2: 25.5163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/no-tasks.3463188e807dcbb5fc306fd30efe3352.svg";
export { ForwardRef as ReactComponent };